<mat-toolbar>
  <mat-nav-list>
    <mat-list-item>
      <a matLine routerLink="/imprint">Imprint</a>
    </mat-list-item>
    <mat-list-item>
      <a matLine routerLink="/data-privacy">Data Privacy</a>
    </mat-list-item>
    <mat-list-item>
      <a matLine routerLink="/disclaimer">Disclaimer</a>
    </mat-list-item>
  </mat-nav-list>
</mat-toolbar>
